import { useEffect } from "react";

// usePipelineCacheInvalidation — BM-H525 (14 Sep 2026).
//
// Extracted verbatim from the inline listener PipelineTrackerCore.jsx has
// carried since WP-J (Reference Fixer): ClientFixerPage.jsx and
// RefFixerPage.jsx write a timestamp to
// sessionStorage["bonsai_pipeline_cache_invalidated_at"] after a successful
// mutation, and the reader listens on window focus, refetching if that
// timestamp is newer than the last time it checked.
//
// PipelineTrackerCore was the only reader of the flag. LinkAMLModal (used
// from PipelineTrackerCore, a different route from MatterDetail.jsx) never
// wired an AML link/override into it, and MatterDetail.jsx — which shows
// the CMRA/SoF/renewal gate badges — never listened at all, so approving
// an AML override left the matter page showing the stale pre-approval
// state until a hard refresh. Rather than bolt on a second one-off
// mechanism, this hook lets any page reuse the exact same pattern by
// passing in its own refetch callback.
//
// Behaviour is byte-identical to the block this replaces in
// PipelineTrackerCore.jsx — same `lastSeen` closure, same try/catch
// swallowing, same immediate `check()` call on mount, same focus listener,
// same cleanup.
export function usePipelineCacheInvalidation(refetch) {
  useEffect(() => {
    let lastSeen = 0;
    const check = () => {
      try {
        const raw = sessionStorage.getItem("bonsai_pipeline_cache_invalidated_at");
        if (!raw) return;
        const ts = Number(raw);
        if (ts > lastSeen) {
          lastSeen = ts;
          refetch();
        }
      } catch (e) {}
    };
    const handler = () => check();
    window.addEventListener("focus", handler);
    check();
    return () => window.removeEventListener("focus", handler);
  }, [refetch]);
}
